export const environment = {
  production: true,
  sentryEnvironment: 'production',
  sentryEnabled: true,
  basePath: window.location.origin,
  chronicleGuestWrites: true,
};
